import { useQuery } from '@tanstack/react-query';
import { supabase } from '../supabaseClient';

/**
 * Whether an event has a group you could join: not yours, not already requested. "Find a Group" shows only then
 * (Sam, 2026-10-20) - otherwise the way in is Create a Group. Under ['groups'], so a join, leave or new group refetches it.
 */
export function useJoinableEventGroups(eventId, { enabled = true } = {}) {
  const query = useQuery({
    queryKey: ['groups', 'joinable', eventId],
    enabled: Boolean(eventId) && enabled,
    staleTime: 30_000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc('list_event_groups', { p_event_id: eventId });
      if (error) throw error;
      return (data ?? []).filter((g) => !g.is_member && !g.has_pending_request && !g.is_full);
    },
  });
  return { joinable: query.data ?? [], canFindGroup: (query.data?.length ?? 0) > 0 };
}
